import { useState, forwardRef, useImperativeHandle } from "react";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import CalendarTable from "./calendar_table";
import strFunc from "@/lib/lyg/string";
import DateFunc from '@/lib/lyg/date_func';
import { useNavigate } from 'react-router-dom';
import TopYearMonthArea from "@/pcomponents/common/crud/calendar/area/top_year_month";

const CalendarArea = forwardRef((props: any, ref) => {
  let myProps = {
    select_date: "",
    set_select_date: (inData: any) => { },
    open_write_discover_map: (inData: any) => { },
    ...props
  };
  let select_date = myProps.select_date;
  if (strFunc.is_empty(select_date)) {
    select_date = DateFunc.get_date_format(new Date(), "Y-m-d");
  }
  const navigate = useNavigate();
  const [discover_info_arr, set_discover_info_arr] = useState([]);
  const [select_stu_seq_arr, set_select_stu_seq_arr] = useState([]);
  const [select_stu_info_arr, set_select_stu_info_arr] = useState([]);

  const setInitData = (inData: any) => {
    let opt_obj = {
      select_date: select_date,
      stu_seq_arr: select_stu_seq_arr,
      ...inData
    };
    if (strFunc.is_empty(opt_obj.select_date)) {
      opt_obj.select_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    list_discover_by_ajax({
      select_date: opt_obj.select_date,
      stu_seq_arr: opt_obj["stu_seq_arr"],
    });
    get_stu_info_by_ajax({
      stu_seq_arr: opt_obj["stu_seq_arr"],
    });
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setInitData
  }));

  const list_discover_by_ajax = (inData: any) => {
    let opt_obj = {
      select_date: select_date,
      stu_seq_arr: select_stu_seq_arr,
      ...inData
    };
    if (strFunc.is_empty(opt_obj.select_date)) {
      opt_obj.select_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    set_select_stu_seq_arr(opt_obj.stu_seq_arr);
    if (strFunc.is_empty(opt_obj["stu_seq_arr"])) {
      if (opt_obj.is_all_show == false) {
        set_discover_info_arr([]);
        return false;
      }
    }
    //let cal_data = LygCalendarFunc.get_cal_data_by_select_date(select_date);
    let s_start_date = DateFunc.get_date_format(new Date(opt_obj.select_date), "Y-m-01");
    let s_end_date = DateFunc.get_date_format(new Date(opt_obj.select_date), "Y-m-t");
    let from_json_data: any = {
      "s_date_type": "a_date",
      "s_start_date": s_start_date,
      "s_end_date": s_end_date,
      "s_stu_seq": opt_obj.stu_seq_arr,
      "order_id": "a_date",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/discover_map/list', from_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_discover_info_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const get_stu_info_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq_arr: select_stu_seq_arr,
      ...inData
    };
    let tmp_stu_seq_arr = [];
    if (opt_obj.stu_seq_arr && opt_obj.stu_seq_arr.length > 0) {
      for (let i = 0; i < opt_obj.stu_seq_arr.length; i++) {
        if (opt_obj.stu_seq_arr[i]) {
          tmp_stu_seq_arr.push(opt_obj.stu_seq_arr[i]);
        }
      }
    }
    if (tmp_stu_seq_arr.length == 0) {
      set_select_stu_info_arr([]);
      return false;
    }
    let form_json_data: any = {
      s_seq: tmp_stu_seq_arr,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_select_stu_info_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  return (
    <div>
      <TopYearMonthArea
        select_date={select_date}
        set_select_date={(inData: any) => {
          myProps.set_select_date(inData);
        }}
        is_show_day_arrow={true}
        sub_addon_text={(
          <>
            <span style={{ position: "absolute", left: 0,bottom:1 }} >
              {select_stu_info_arr.length > 0 &&
                select_stu_info_arr.map((stu_info: any, stu_idx: number) => {
                  return (
                    <span key={stu_idx} style={{ marginLeft: 10, fontSize: "24px", fontWeight: "bold" }}>
                      {stu_info["a_user_name"]}
                    </span>
                  );
                })
              }
            </span>
          </>
        )}
      ></TopYearMonthArea>
      <div style={{ display: "none" }}>
        <div style={{ display: "inline-block", height: 28, width: 1 }}></div>
        <span>
          {select_date.substring(0, 4)}년 {select_date.substring(5, 7)}월
        </span>
        <span className="ml-2">
          {select_stu_seq_arr.length}명
        </span>
        <span className="ml-2">
          {discover_info_arr.length}건
        </span>
      </div>
      <div className="mt-1">
        <CalendarTable
          select_date={select_date}
          set_select_date={(inData: any) => {
            myProps.set_select_date(inData);
          }}
          discover_info_arr={discover_info_arr}
          select_stu_seq_arr={select_stu_seq_arr}
          open_write_discover_map={myProps.open_write_discover_map}
        ></CalendarTable>
      </div>
    </div>
  );
});
export default CalendarArea;